import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=5d8be5dc&"
import script from "./authorization.vue?vue&type=script&lang=js&"
export * from "./authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports